import React from "react";
import { Check } from "lucide-react";
import { PACKAGES } from "../mock";
import { useEnquiry } from "../context/EnquiryContext";

const Packages = () => {
  const { open: openEnquiry } = useEnquiry();
  return (
    <section id="packages" className="py-24 md:py-32 bg-[#efe7d6]">
      <div className="max-w-[1400px] mx-auto px-6 md:px-10">
        <div className="text-center max-w-2xl mx-auto mb-20 reveal">
          <p className="kicker mb-5">Packages</p>
          <h2 className="font-display display-tight text-5xl md:text-6xl text-[#1f1d1a]">
            Simple pricing.<br/>
            <span className="italic font-light">No surprises.</span>
          </h2>
          <div className="section-rule mx-auto mt-8" />
          <p className="mt-6 text-[#3a342c]/80 font-light">
            Every package includes full digital delivery, no travel charges, and interest-free monthly payments.
          </p>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-2 gap-6 md:gap-8">
          {PACKAGES.map((p, i) => (
            <div key={i} className={`pkg-card p-8 md:p-10 reveal flex flex-col ${p.featured ? "featured" : ""}`}>
              {p.badge && (
                <p className="kicker mb-5">{p.badge}</p>
              )}
              {!p.badge && <p className="kicker mb-5 opacity-0">.</p>}
              <h3 className="font-display display-tight text-3xl md:text-4xl mb-4">{p.title}</h3>
              <p className={`text-sm font-light leading-relaxed mb-7 ${p.featured ? "text-[#e8dfc9]/90" : "text-[#6b6259]"}`}>
                {p.desc}
              </p>

              <div className="flex items-baseline gap-3 mb-7 pb-7 border-b border-current/15">
                <span className="font-display text-4xl md:text-5xl display-tight">{p.price}</span>
                <span className={`text-xs ${p.featured ? "text-[#c9a87c]" : "text-[#8b6f47]"}`}>{p.monthly}</span>
              </div>

              <ul className="space-y-3 mb-9 flex-1">
                {p.bullets.map((b, j) => (
                  <li key={j} className="flex items-start gap-3 text-sm font-light leading-relaxed">
                    <Check size={15} className={`mt-1 flex-shrink-0 ${p.featured ? "text-[#c9a87c]" : "text-[#8b6f47]"}`} />
                    <span className={p.featured ? "text-[#e8dfc9]" : "text-[#3a342c]"}>{b}</span>
                  </li>
                ))}
              </ul>

              <button onClick={openEnquiry} className="btn-primary w-full justify-center">
                Claim My Date
              </button>
            </div>
          ))}
        </div>

        <p className="text-center mt-12 italic font-serif text-[#6b6259] reveal">
          Interest-free monthly payments available on all packages.
        </p>
      </div>
    </section>
  );
};

export default Packages;
